import { listField } from "./config";
import component from "./MassPayPayout.vue";

export default {
  component,
  listField,
};

export const selector = (selectedPayoutSystem: string | null): boolean => {
  return selectedPayoutSystem === "masspay";
};
